import React from 'react'
import ReactDOM from 'react-dom/client'
import { Router } from 'wouter'
import App from './App'
import '../app/globals.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
)